// TODO: Use GQL tag here instead of string concatenation
const SlugAvailableQuery = (slug: string) => `
  query SlugAvailableQuery {
    slugAvailable(slug: "${slug}")
  }
`;

export default SlugAvailableQuery;
